import { render, staticRenderFns } from "./notifications.vue?vue&type=template&id=75ea4770&"
import script from "./notifications.vue?vue&type=script&lang=ts&"
export * from "./notifications.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('75ea4770')) {
      api.createRecord('75ea4770', component.options)
    } else {
      api.reload('75ea4770', component.options)
    }
    module.hot.accept("./notifications.vue?vue&type=template&id=75ea4770&", function () {
      api.rerender('75ea4770', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/components/notifications/notifications.vue"
export default component.exports